import { ActionContext } from 'vuex';
import { IQuoteState } from '@/store/quote/quote.state';
import { DocumentApi, QuoteApi, TenantSettingsApi, UserApi } from '@phrospr/api-backend';

export const quoteActions = {
    async loadQuoteAttachments(context: ActionContext<IQuoteState, IQuoteState>) {
        const { attachmentLastSync } = context.state;
        if (
            attachmentLastSync !== undefined &&
            attachmentLastSync.getTime() > new Date().getTime() - 1000 * 60 * 5 // 5 minutes ago
        )
            return;

        const quoteAttachmentList = (await DocumentApi.listDocuments('quote_attachment' as any, false)).data;
        context.commit('setQuoteAttachments', quoteAttachmentList);
        // The budget line is informative and the server enforces it on save, so a failed read must
        // not block the quote form.
        const attachmentBudgetBytes = await TenantSettingsApi.getQuoteMailSettings()
            .then(res => res.data?.attachmentBudgetBytes ?? null)
            .catch(() => null);
        context.commit('setAttachmentBudget', attachmentBudgetBytes);
    },
    async loadQuoteUsers(context: ActionContext<IQuoteState, IQuoteState>) {
        const { quoteUsersLastSync } = context.state;
        if (
            quoteUsersLastSync !== undefined &&
            quoteUsersLastSync.getTime() > new Date().getTime() - 1000 * 60 * 5 // 5 minutes ago
        )
            return;

        const users = (await UserApi.listUsers()).data.filter(user => !user.data.ignoreUserInSellerList);
        context.commit('setQuoteUsers', users);
    },
    async startQuoteUpsert(context: ActionContext<IQuoteState, IQuoteState>, quoteId?: number) {
        if (context.state.isCachedUpsertQuote === true) {
            context.commit('removeCacheQuoteV2');
            if (context.state.upsertQuote !== undefined) return;
        }
        context.commit('resetQuoteV2');
        if (quoteId === undefined) return context.commit('createNewQuoteV2');
        const quote = (await QuoteApi.getQuote(quoteId)).data;
        context.commit('updateQuoteV2', quote);
        context.commit('setSelectedClientQuote', quote.client);
    },
};
